// extracted by mini-css-extract-plugin
export default {"audit-main-container":"Audit_audit-main-container__rO6t1","autdit-tabel-container":"Audit_autdit-tabel-container__QmNHp","audit-title-container":"Audit_audit-title-container__+RMuS"};